export default "__VITE_ASSET__CRTCqvQA__"